import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>SlimBuddy</h3>
            <p>Your AI-powered weight loss companion</p>
            <div className="social-links">
              <a href="#" aria-label="Instagram">📷</a>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="link-group">
              <h4>Contact Us</h4>
              <ul>
                <li><Link to="/contact">Get in Touch</Link></li>
                <li><a href="mailto:info@slimbuddy.ai">info@slimbuddy.ai</a></li>
              </ul>
            </div>
            
            <div className="link-group">
              <h4>Policies</h4>
              <ul>
                <li><Link to="/terms">Terms & Conditions</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/disclaimer">Important Disclaimer</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} SlimBuddy. QFL Capital LLC. All rights reserved.</p>
          <p className="footer-tagline">
            Made with ❤️ for a healthier world
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;